import React from 'react';
import { Github, Linkedin, MessageSquareMore, Mail } from 'lucide-react';
import { usePortfolio } from '../context/PortfolioContext';

const Footer = () => {
  const { portfolioData } = usePortfolio();
  const hero = portfolioData?.hero;
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-gray-200 bg-gray-100 py-8 transition-colors duration-300 dark:border-[#1f2937] dark:bg-[#0f1419]">
      <div className="container mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-6xl">
          <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
            <p className="text-center text-sm text-gray-600 dark:text-gray-400 sm:text-left">
              © {currentYear} TRAORE Djakaridia. Tous droits réservés.
            </p>
            <div className="flex items-center justify-center gap-3 text-gray-600 dark:text-gray-400">
              <a
                href={hero?.whatsapp || '#'}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-700 dark:text-gray-300 hover:text-emerald-400 dark:hover:text-emerald-300 transition-all duration-300 hover:scale-110"
              >
                <MessageSquareMore className="w-5 h-5" />
              </a>
              <a
                href={`mailto:${hero?.email || ''}`}
                className="text-gray-700 transition-colors hover:text-emerald-400 dark:text-gray-300 dark:hover:text-emerald-300"
                aria-label="Email"
              >
                <Mail className="h-5 w-5" />
              </a>
              <a
                href={hero?.github || '#'}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-700 transition-colors hover:text-emerald-400 dark:text-gray-300 dark:hover:text-emerald-300"
                aria-label="GitHub"
              >
                <Github className="h-5 w-5" />
              </a>
              <a
                href={hero?.linkedin || '#'}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-700 transition-colors hover:text-emerald-400 dark:text-gray-300 dark:hover:text-emerald-300"
                aria-label="LinkedIn"
              >
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;